import React, { useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid } from "@material-ui/core";
import Alert from '@material-ui/lab/Alert';
import { CardSelectorTemplate } from "../../atoms/inputElemets/CardSelector";
import { getTemplates } from '../../../store/blueprint/actions';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { getTemplateClusterlets } from '../../../store/constructs/templated_clusterlet/selectors';
import { addTemplatedClusterlet } from '../../../store/constructs/templated_clusterlet/actions';
import { handleSnackBar } from '../../../store/global/actions';
import { Pagination } from '@material-ui/lab';
import Divider from '@material-ui/core/Divider';
import { templateConfig } from '../../../config/common'


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > * + *': {
            marginLeft: theme.spacing(2),

        },
        alignItems: 'center',
        justifyContent: 'center',
        display: "flex"
    },
}));

export const ClusterletTemplates = ({ clusterletDetails, onClose, onCompletion }) => {

    const [selectedTemplate, setSelectedTemplate] = useState("");
    const [templates, setTemplates] = useState([]);
    const [error, setError] = useState(true);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const classes = useStyles();
    const templatesInStore = useSelector(getTemplateClusterlets);
    const [numberOfPages, setNumberOfPages] = useState(0);
    const [page, setPage] = useState(1);
    let rowsPerPage = templateConfig.rowsPerPage || 6;



    useEffect(() => {
        setError(false);
        setLoading(true);
        dispatch(getTemplates(page, rowsPerPage)).then((result) => {
            if (result.status) {
                const templateFormatted = result.templates.map(item => (
                    {
                        ...item,
                        id: item.template,
                    }
                ))
                let totCount = result?.recordCount % rowsPerPage;
                setNumberOfPages(totCount === 0 ? parseInt(result?.recordCount / rowsPerPage) : parseInt(result?.recordCount / rowsPerPage) + 1)
                setTemplates(templateFormatted);
                setLoading(false)
            }
            else {
                setError(true);
                setLoading(false)
            }
        })
    }, [page])

    const onClick = (value) => setSelectedTemplate(value);

    const templateDetails = (item) => {
        // console.log('detail')
    }

    const importTemplate = (item) => {
        const isDuplicate = templatesInStore.some(template => template.name === item.template);
        if (isDuplicate) {
            dispatch(handleSnackBar({ open: true, message: `${item.name} is already imported!`, severity: "warning" }));
            return;
        }
        clusterletDetails.name = item.template;
        clusterletDetails.metajson = item.meta;
        clusterletDetails.icon = item.imagePath ? item.imagePath : '';

        dispatch(addTemplatedClusterlet(clusterletDetails));
        //dispatch(addTemplateToApp(clusterletDetails));
        onCompletion();
    }


    const actionButtons = [
        { label: 'Use', action: importTemplate, size:'medium', variant: 'outlined' }
    ]

    return (

        <Grid container spacing={2}>

            <Grid item xs={12}>
                {templates.length == 0 && !loading && !error && <Alert severity="info">No templates avialable </Alert>}

                {error && <Alert severity="error">Failed to fetch the tempates</Alert>}

            </Grid>

            {loading && <Grid item xs={12} className={classes.root}><CircularProgress /></Grid>}

            <Grid item xs={12}>
                <CardSelectorTemplate
                    justify={"flex-start"}
                    list={templates.sort((a, b) => (a.template.toLowerCase() > b.template.toLowerCase() ? 1 : -1))}
                    onClick={onClick}
                    value={selectedTemplate}
                    isFromTemplate={true}
                    actionButtons={actionButtons}
                />

            </Grid>

            <Grid item xs={12}>
                <Divider variant='fullWidth' />
            </Grid>

            <Grid item xs={12}>

                <Pagination
                    count={numberOfPages}
                    color='secondary'
                    varient='outlined'
                    page={page}
                    onChange={(event, value) => setPage(value)}
                    style={{ display: "flex", justifyContent: "flex-end" }}
                />
            </Grid>
        </Grid>

    )

}